import { ReactNode } from 'react';

import { AccordionItemProps, Item as RadixItem } from '@radix-ui/react-accordion';
import { twMerge } from 'tailwind-merge';

interface SectionItemProps extends AccordionItemProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function Item({ children, className, ...props }: SectionItemProps) {
  return (
    <RadixItem className={twMerge('rounded-xl bg-white', className)} {...props}>
      {children}
    </RadixItem>
  );
}

export { Item };
